var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellFilled = function SvgBellFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.576 21a4.99 4.99 0 0 1-9.152 0zM11.441.002a9.32 9.32 0 0 1 9.215 6.824l1.736 5.723A5 5 0 0 1 17.607 19H6.09a5 5 0 0 1-4.858-6.184L2.58 7.28A9.32 9.32 0 0 1 11.44.002"
  })));
};
export default SvgBellFilled;